var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.company.siteBuildTitle'),"action":"create","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"flex flex-col w-full mb-2"},[_vm._v(" "+_vm._s(_vm.$t('modals.company.siteBuildText'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }